/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {ID} from '../../_metronic/helpers'
import {MenuComponent} from '../../_metronic/assets/ts/components'
import {Link} from 'react-router-dom'

import {Edit, EyeIcon, Trash2, View} from 'lucide-react'
import {DeleteModal} from './DeleteModal'

type Props = {
  id: ID
  setItemIdToView: (id: ID) => void
  setItemIdForUpdate?: (id: ID) => void
  deleteAction?: (id: ID) => Promise<void>
  model: string
  refetch?: () => void
  editUrl?: string
}

export const ActionsCell: FC<Props> = (props) => {
  const {id, setItemIdToView, setItemIdForUpdate, refetch, deleteAction} = props
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openFetchModal = () => {
    setItemIdToView(id)
  }

  const openEditModal = () => {
    if (setItemIdForUpdate) {
      setItemIdForUpdate(id)
    }
  }

  return (
    <>
      <div className='relative inline-block'>
        <a
          href='#'
          className='btn btn-sm bg-white text-primary hover:bg-primary/10 font-medium'
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'
        >
          <span>
            Actions
            <EyeIcon className='w-4 h-4 ml-1' />
          </span>
        </a>

        {/* Dropdown menu */}
        <div
          className='mt-2 w-32 rounded-lg bg-gray-100 text-gray-700 text-sm font-semibold shadow-lg py-2 absolute right-0 z-50 text-center'
          data-kt-menu='true'
        >
          <div className='px-3 py-1 hover:bg-primary-100 text-primary-600 cursor-pointer'>
            <a className='flex items-center justify-between w-full' onClick={openFetchModal}>
              <span>Fetch</span>
              <View className='w-4 h-4 text-primary-500 ml-2' />
            </a>
          </div>

          {props.editUrl ? (
            <div className='px-3 py-1 hover:bg-primary-100 text-primary-600 cursor-pointer'>
              <Link
                to={props.editUrl.replace(':id', id?.toString() || '')}
                className='flex items-center justify-between w-full'
              >
                <span>Edit</span>
                <Edit className='w-4 h-4 text-primary-500 ml-2' />
              </Link>
            </div>
          ) : (
            setItemIdForUpdate && (
              <div className='px-3 py-1 hover:bg-primary-100 text-primary-600 cursor-pointer'>
                <a className='flex items-center justify-between w-full' onClick={openEditModal}>
                  <span>Edit</span>
                  <Edit className='w-4 h-4 text-primary-500 ml-2' />
                </a>
              </div>
            )
          )}

          {deleteAction && (
            <div className='px-3 py-1 hover:bg-red-100 text-red-600 cursor-pointer'>
              <a
                className='flex items-center justify-between w-full'
                onClick={() => setShowDeleteConfirm(true)}
              >
                <span>Delete</span>
                <Trash2 className='w-4 h-4 text-red-500 ml-2' />
              </a>
            </div>
          )}
        </div>
      </div>
      <DeleteModal
        showDeleteConfirm={showDeleteConfirm}
        setShowDeleteConfirm={setShowDeleteConfirm}
        deleteAction={deleteAction}
        refetch={refetch}
        id={id}
      />
    </>
  )
}
